var CadastroForm = function () {

    this.init = function () {

        $('[data-component="cadastro-form"] .scrollbar-inner').scrollbar();

        $('#cadastroFormValidate').validate({
            ignore: '.ignore',
            errorPlacement: function () {
                return true;
            },
            rules: {
                nome: {
                    required: true,
                },
                empresa: {
                    required: true,
                },
                segmento: {
                    required: true,
                },
                funcionarios: {
                    required: true,
                },  
                email: {
                    required: true,
                    email: true
                },
                password: {
                    required: true,
                    minlength: 5    
                },
                confirm_password: {
                    required: true,
                    minlength: 5,
                    equalTo: "#password"
                }
            },
            submitHandler: function (form) {

                var submittedForm = $(form);
                var componentID = parseInt(submittedForm.data("id"));

                submittedForm.find("button[type='submit']").attr("disabled", true);

                var cadastroData = {
                    "Email": submittedForm.find("input[name='email']").val(),
                    "Password": submittedForm.find("input[name='password']").val(),
                    "Name": submittedForm.find("input[name='nome']").val(),
                    "Company": submittedForm.find("input[name='empresa']").val(),
                    "Segment": submittedForm.find("select[name='segmento']").val(),
                    "NumberOfEmployees": submittedForm.find("select[name='funcionarios']").val()
                };

                $.ajax({
                    type: "POST",
                    url: "/umbraco/surface/members/create",
                    data: JSON.stringify(cadastroData),
                    dataType: "json",
                    async: true,
                    contentType: "application/json; charset=utf-8",
                    success: function success(response) {

                        if(response == true){
                            $("#cadastroFormValidate").each(function () {
                                this.reset();
                            });
                            $('#modal-header').find('#isMemberLogged').val("true");
                            $("#cadastro-form").css("display", "none");
							$("#cadastro-confirmacao").css("display", "block");
							window.dataLayer.push({'event':'EventoSimples', 'gacategoria': 'Cadastro', 'garotulo': 'Efetuado', 'gaacao': 'click'});

                        }
                        else if(response == false){
                            $("#cadastro-form").find(".error").text("Ocorreu um erro, tente novamente mais tarde");
                        }
                        else if(response.length > 0){
                            $("#cadastro-form").find(".error").text(response);
                        }
                    },
                    error: function error(e) {
                        $("#cadastro-form").find(".error").text("Ocorreu um erro, tente novamente mais tarde");
                    },
                    complete: function () {
                        submittedForm.find("button[type='submit']").attr("disabled", false);
                    }
                });
            }
        });
    }

    return this.init();
}